import { render, staticRenderFns } from "./Network-permission.vue?vue&type=template&id=1f22af24&scoped=true&"
import script from "./Network-permission.vue?vue&type=script&lang=js&"
export * from "./Network-permission.vue?vue&type=script&lang=js&"
import style0 from "./Network-permission.vue?vue&type=style&index=0&id=1f22af24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22af24",
  null
  
)

export default component.exports